import { Component, Input, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { FormsServiceService } from '../../../api/services/forms-service.service';
import { getAvatarBgColor } from '../../../helpers/avatar.helper';
import { InitialsService } from '../../../helpers/initial.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-resources-card',
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './resources-card.component.html',
  styleUrl: './resources-card.component.css',
})
export class ResourcesCardComponent {
  endpoint = environment.api_endpoint;
  @Input() formGroup!: FormGroup;
  @Input() fields: any;
  @Input() formID: any;
  @Input() maxHeight: any;
  @Input() currentSelectedName: any;
  fieldsData: any;
  noData: boolean = false;
  assetIcons: { [key: string]: string } = {
    Laptop: 'laptops.png',
    'Access Points': 'accesspoints.png',
    'Cameras (CCTV/IP)': 'cameras.png',
    Computers: 'computers.png',
    Desktop: 'computers.png',
    'Docking Stations': 'dockingstations.png',
    Documents: 'documents.png',
    Domains: 'domains.png',
    'External Drives': 'externaldrives.png',
    Firewall: 'firewalls.png',
    Headphones: 'headphones.png',
    'IoT Devices': 'iotdevices.png',
    Keyboards: 'keyboards.png',
    'Mobile Devices': 'mobiledevices.png',
    'Network Cables': 'networkcables.png',
    'Power Adapters': 'poweradapters.png',
    Printers: 'printers.png',
    Projectors: 'projectors.png',
    Router: 'routers.png',
    SaaS: 'saas.png',
    'Security Tokens': 'securitytoken.png',
    Servers: 'server.png',
    'Smart TVs': 'smarttv.png',
    'Social Media Links': 'socialmedialinks.png',
    'Software Licenses': 'softwarelicenses.png',
    SSL: 'ssl.png',
    Switches: 'switches.png',
    Tablets: 'tablets.png',
    'UPS Devices': 'upsdevices.png',
    Webcams: 'webcams.png',
    'Wi-Fi': 'wifi.png',
  };
  groupedData: any[] = [];
  constructor(
    private formService: FormsServiceService,
    private initialsService: InitialsService,
    private cdr: ChangeDetectorRef,
  ) {}
  ngOnInit() {
    this.getData();
  }

  /** Function to get the data by api or static */
  getData() {
    if (this.fields?.options?.isStatic === true) {
      this.fieldsData = this.fields?.options?.staticOptions;
    } else {
      const formId = this.formID || this.fields?.options?.source?.formID;
      const api_endpoint = this.endpoint;
      const method = this.fields?.options?.source?.method;
      let url = this.fields?.options?.source?.apiUrl;

      // Replace tokens in URL
      const replacements = {
        formID: formId,
        api_endpoint: api_endpoint,
      };
      url = this.formService?.replaceTemplateTokens(url, replacements);

      // Add provider query param
      url += `${url.includes('?') ? '&' : '?'}provider=${encodeURIComponent(this.currentSelectedName)}`;
      const headers = {
        'Content-Type': 'application/json',
      };

      // ✅ Pass the body to loadData
      this.formService?.loadData(method, url, headers, 30).subscribe({
        next: (res: any) => {
          this.fieldsData = res.data.records;
          const counts: any = {};
          this.fieldsData.forEach((item: any) => {
            const typeName = item.type.split('/').pop();

            if (!counts[typeName]) {
              counts[typeName] = {
                name: item.name,
                type: typeName,
                itemcount: 0,
                iconType: item.type,
              };
            }

            counts[typeName].itemcount++;
          });

          this.groupedData = Object.values(counts);
          this.cdr.detectChanges();
        },
        error: (err: any) => {
          if (err.status === 404) {
            this.noData = true;
          }
          this.cdr.detectChanges();
        },
      });
    }
  }

  getInitials(name: string): string {
    return this.initialsService.getInitials(name);
  }

  /** Show color for the user department wise */
  getBgColorByDepartment(name: string): string {
    return getAvatarBgColor(name);
  }

  getIcon(name: string): string {
    const icon = this.assetIcons[name];
    return icon
      ? `./assets/media/assets/${icon}`
      : './assets/media/data-view/asset.png';
  }
}
